// https://webpack.js.org/configuration/output/#output-publicpath
//
// > In cases where the publicPath of output files can't be known at compile time, it can be
// > left blank and set dynamically at runtime in the entry file using the free variable
// > __webpack_public_path__

import { retrieve } from 'putki';

// eslint-disable-next-line no-undef, camelcase
__webpack_public_path__ = retrieve('webpack_public_path');
